import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';

export default class GridCell extends Component {
  static propTypes = {
    size: PropTypes.number.isRequired,
    smallSize: PropTypes.number,
    xSmallSize: PropTypes.number
  };

  static defaultProps = {
    size: 6,
    smallSize: null,
    xSmallSize: null
  };

  render() {
    let size = this.props.size,
      smallSize = this.props.smallSize || size,
      xSmallSize = this.props.xSmallSize || size,
      classes = ClassNames(
        this.props.className,
        'col-md-' + size,
        'col-xs-' + xSmallSize,
        'col-sm-' + smallSize
      );
    return (
      <div className={classes} style={{ transition: '0.25s all ease' }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Grid/GridCell.js